module.exports = __webpack_public_path__ + "media/images/leads_generation/illustration-projectmanager-d90c1a08a5d55e32fe11bcbf660169e0.svg";